export { default } from './ArticlePagination';
